/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import { Card, Icon, Tab, Tooltip } from '@scuf/common';
import SiteEnergyUsageComponent from './SiteEnergyUsage/SiteEnergyUsageKPI';
import './EmaasMobileSupervisorSiteCard.scss';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import IEnergyManagementProps from '../IEnergyManagementProps';
import SiteEUIComponent from './SiteEUI/SiteEUIKPI';
import { TabIndex } from '../../shared/Utils/Constants';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import { getTabs } from '../../shared/Utils/CommonWidgetUtils';
import SiteCarbonComponent from './SiteCarbon/SiteCarbonKPI';
import SiteUtilityComponent from './SiteUtility/SiteUtilityKPI';
import { withLocalization } from '../../../locales/withLocalization';

export const showSelctedToggleView = (
  activeIndex: number,
  {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    preferredEuiUnit,
    displayWidgets,
    displayBaseline
  }: IEnergyManagementProps
) => {
  const activeWidgetName = displayWidgets![activeIndex];
  if (activeWidgetName == 'carbon') {
    return (
      <SiteCarbonComponent
        connectorConfig={connectorConfig}
        bearerToken={bearerToken}
        requestContext={requestContext}
        emaasContext={emaasContext}
        displayBaseline={displayBaseline}
      />
    );
  }
  if (activeWidgetName == 'energy') {
    return (
      <SiteEnergyUsageComponent
        connectorConfig={connectorConfig}
        bearerToken={bearerToken}
        requestContext={requestContext}
        emaasContext={emaasContext}
        displayBaseline={displayBaseline}
      />
    );
  }
  if (activeWidgetName == 'eui') {
    return (
      <SiteEUIComponent
        connectorConfig={connectorConfig}
        bearerToken={bearerToken}
        requestContext={requestContext}
        emaasContext={emaasContext}
        preferredEuiUnit={preferredEuiUnit}
      />
    );
  }
  if (activeWidgetName == 'utility') {
    return (
      <SiteUtilityComponent
        connectorConfig={connectorConfig}
        bearerToken={bearerToken}
        requestContext={requestContext}
        emaasContext={emaasContext}
        preferredEuiUnit={preferredEuiUnit}
        displayBaseline={displayBaseline}
      />
    );
  }
};

function EmaasMobileSupervisorSiteCard(props: IEnergyManagementProps) {
  const {
    emaasContext,
    displayWidgets,
    displayLable,
    tooltipContent,
    optimusSubscribed
  } = props;
  const [activeIndex, SetactiveIndex] = useState(0);
  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  return (
    <ContextProvider
      value={updateApiConfig({
        ...emaasContext
      })}
    >
      <div className="emaas-ms-site-kpi-card">
        <Card>
          <Card.Header className="kpi-header-container">
            <div className="kpi-card-tab">
              <Tab
                defaultActiveIndex={0}
                onTabChange={(index) => SetactiveIndex(index)}
              >
                {getTabs(t, displayWidgets!, displayLable).map((tab) => tab)}
              </Tab>
            </div>
            {optimusSubscribed && (
              <Tooltip
                element={<Icon root="common" name="badge-info" size="small" />}
                event="hover"
                content={tooltipContent}
                position="right center"
                size="small"
                className="optimus-tooltip-icon"
              />
            )}
          </Card.Header>
          <Card.Content className="kpi-content-container">
            {showSelctedToggleView(activeIndex, props)}
          </Card.Content>
        </Card>
      </div>
    </ContextProvider>
  );
}

export default withLocalization<IEnergyManagementProps>(
  EmaasMobileSupervisorSiteCard
);
